export default __webpack_public_path__ + "b24693e49b7807936f5b60074cc6df36.png";